module.exports = __webpack_public_path__ + "static/media/instagram.c49067b7.svg";